import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { notFoundRoute, redirects, routes } from '../routes';
import { SITE_URL } from '../lib/routeMeta';

/**
 * Applies per-route SEO meta on navigation: document.title, the description
 * meta, and the canonical link (kept in sync with SITE_URL so staging
 * rewrites propagate). index.html carries the home-page values for the
 * initial paint and crawlers that don't run JS.
 */
export function RouteMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Redirect stubs (/giveaway -> /sweepstakes) unmount in the same tick, so
    // leave the meta alone rather than stamping a 404 title + a canonical
    // pointing at the stale path for one frame. The effect re-runs on the
    // destination and applies its values.
    if (redirects.some((r) => r.from === pathname)) return;

    const meta = routes.find((r) => r.path === pathname)?.meta ?? notFoundRoute.meta;
    document.title = meta.title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', meta.description);
    document
      .querySelector('link[rel="canonical"]')
      ?.setAttribute('href', `${SITE_URL}${pathname === '/' ? '' : pathname}`);
  }, [pathname]);

  return null;
}
